/* [PATCH dc-skupina-fe v1] Nastavitve DČ → kartica »Skupinski pregled dela« (odločitev 101): izbira baz, kjer je
   uporabnik administrator Delovnega časa. Nastavitev je UPORABNIKA (enaka v vsaki bazi). Pri >= 2 izbranih se v meniju
   Delovnega časa pokaže »Skupinski pregled dela«. API: GET/POST /dc-skupina/baze. */
import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

const kartica = 'bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700 p-5';
const gumb = 'px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50';
const napaka = (e: any) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === 'string' ? e.response.data.detail : JSON.stringify(e.response.data.detail))
  : (e?.message || 'Napaka');

export function DcSkupinaKartica() {
  const [baze, setBaze] = useState<any[] | null>(null);
  const [izb, setIzb] = useState<string[]>([]);
  const [msg, setMsg] = useState<{ tip: string; t: string } | null>(null);
  const [dela, setDela] = useState(false);
  useEffect(() => {
    api.get('/dc-skupina/baze').then((r: any) => {
      const b: any[] = r.data?.baze || [];
      setBaze(b); setIzb(b.filter((x: any) => x.izbrana).map((x: any) => x.id));
    }).catch((e: any) => { setBaze([]); setMsg({ tip: 'napaka', t: napaka(e) }); });
  }, []);
  const shrani = async () => {
    setDela(true); setMsg(null);
    try {
      await api.post('/dc-skupina/baze', { company_ids: izb });
      setMsg({ tip: 'ok', t: izb.length >= 2 ? `Shranjeno — ${izb.length} baz. »Skupinski pregled dela« je v meniju Delovnega časa.` : 'Shranjeno. Za skupinski pregled izberi vsaj dve bazi.' });
      window.dispatchEvent(new Event('dc-skupina-spremenjena'));
    } catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); } finally { setDela(false); }
  };
  if (baze === null) return null;
  return (
    <div className={kartica + ' space-y-3'}>
      <div className="text-sm font-semibold">Skupinski pregled dela</div>
      <div className="text-xs text-gray-500">Nastavitev velja zate (ne za podjetje). Izberi baze, kjer si administrator Delovnega časa — v meniju se pokaže »Skupinski pregled dela« z vsemi izbranimi bazami (stolpec Podjetje, izvoz ZIP, zaklep v vseh bazah).</div>
      {baze.length < 2 && <div className="text-xs px-3 py-2 rounded-lg bg-amber-50 text-amber-800 border border-amber-200">Administrator Delovnega časa si v {baze.length} {baze.length === 1 ? 'bazi' : 'bazah'} — skupinski pregled potrebuje vsaj dve.</div>}
      {baze.length > 0 && <div className="flex items-center gap-3 text-xs">
        <button type="button" className="text-blue-600 hover:underline" onClick={() => setIzb(baze.map((x: any) => x.id))}>izberi vse</button>
        <button type="button" className="text-blue-600 hover:underline" onClick={() => setIzb([])}>počisti</button>
        <span className="text-gray-500">izbranih {izb.length}</span></div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 max-h-72 overflow-y-auto">{baze.map((x: any) => (
        <label key={x.id} className="text-sm flex items-center gap-2"><input type="checkbox" checked={izb.includes(x.id)}
          onChange={e => setIzb(e.target.checked ? [...izb, x.id] : izb.filter(i => i !== x.id))} /><span className="truncate" title={x.ime}>{x.ime}</span></label>))}</div>
      {msg && <div className={'text-xs px-3 py-2 rounded-lg border ' + (msg.tip === 'ok' ? 'bg-green-50 text-green-800 border-green-200' : 'bg-red-50 text-red-700 border-red-200')}>{msg.t}</div>}
      <div><button type="button" className={gumb} disabled={dela} onClick={shrani}>Shrani</button></div>
    </div>
  );
}

export default DcSkupinaKartica;
